import {fieldsMixin} from './fields.mixin';

if (document.getElementById('appointmentForm')) {
    
    var app = new Vue({
        el: '#appointmentForm',
        mixins: [ fieldsMixin ],
        data ()  { 
            return {
                subject: '',
                local_fields: {},
                loaded: false
            }
        },

        mounted() {
            document.getElementById('appointmentForm').style.display = 'block'
        },

        methods: {
            hasError () {
                return false;
            }
        },

        
    })
};